import { useMutation } from 'react-query';
import { Credentials, timefitBackend } from '../../Services/TimefitBackend';

export function useSignIn() {
  const mutation = (credentials: Credentials) => timefitBackend.signIn(credentials);

  return useMutation(mutation);
}
